import { getLimitedViews } from '../utils/utils';
var viewReducerGen = function viewReducerGen(args) {
  var minDetail = args.minDetail,
    maxDetail = args.maxDetail;
  return function (state, action) {
    var views = getLimitedViews(minDetail, maxDetail);
    var view = state.view;
    var type = action.type,
      _action$payload = action.payload,
      payload = _action$payload === void 0 ? {} : _action$payload;
    var targetView = payload.targetView;
    switch (type) {
      case 'drillUp':
        if (targetView) {
          if (views.indexOf(targetView) !== -1) {
            return {
              view: targetView
            };
          } else {
            return {
              view: view
            };
          }
        } else {
          var drillUpAvailable = views.indexOf(view) > 0;
          if (drillUpAvailable) {
            var nextView = views[views.indexOf(view) - 1];
            return {
              view: nextView
            };
          } else {
            return {
              view: view
            };
          }
        }
      case 'drillDown':
        if (targetView) {
          if (views.indexOf(targetView) !== -1) {
            return {
              view: targetView
            };
          } else {
            return {
              view: view
            };
          }
        } else {
          var drillDownAvailable = views.indexOf(view) < views.length - 1;
          if (drillDownAvailable) {
            var _nextView = views[views.indexOf(view) + 1];
            return {
              view: _nextView
            };
          } else {
            return {
              view: view
            };
          }
        }
      case 'goTargetView':
        if (targetView) {
          if (views.indexOf(targetView) !== -1) {
            return {
              view: targetView
            };
          } else {
            return {
              view: view
            };
          }
        } else {
          return {
            view: view
          };
        }
      default:
        return {
          view: view
        };
    }
  };
};
export default viewReducerGen;